import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { RedirectToCatalogPage } from '../action-creators';
import { REDIRECT_TO_CATALOG_PAGE } from '../actions';
import { push } from 'connected-react-router';

export const redirectToCatalogPageEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, RedirectToCatalogPage>(REDIRECT_TO_CATALOG_PAGE),
    map((action) => {
      let queryPath = '';

      if (action.tab) {
        queryPath += `type=${action.tab}`;
      }

      if (action.status) {
        queryPath += `&status=${action.status}`;
      }

      if (queryPath) {
        return push(`/catalog?${queryPath}`);
      } else {
        return push('/catalog');
      }
    })
  );
